export default __webpack_public_path__ + "images/multilang-intro-step-3.b5b21ee26e1e271e2a663e2778421c41.png";